<template lang="pug">
  div(:class="`collection conversation conversation-${this._uid} ${this.payload.title && this.payload.title.toLowerCase().split(' ').join('-')}`")

    //- Collection item navigation
    nav.collectionNav.vertical.showProgress(v-if="this.showNavigation")
      ol.collectionNavItems
        li.collectionNavItem(
          v-for="(n, i) in this.payload.items"
          :class="activeId === n.sys.id && 'active'") {{ n.fields.name || i }}
        //- li.collectionNavItem(
          v-for="(n, i) in this.payload.items"
          v-on:click="setActiveItem($event, n.sys.id)"
          :class="activeId === n.sys.id && 'active'") {{ n.fields.name || i }}

      h4(v-if="this.showTitle").title.collection-title {{ this.payload.title }}

    div(v-if="this.showResult")
      h1 The results are in!
      p Your score:
      ul
        li(v-for="(n, i) in this.splitScores") {{n.name}}: {{n.value}}
      .button.minimal(v-on:click="saveResult") Save &amp; send

    div(v-for="(n, i) in payload.items"
    v-if="!showResult")
      question(v-on:next-question="next" :payload="n.fields" :id="n.sys.id" :index="i" v-if="!showNavigation || activeId === n.sys.id")

    a(v-if="this.payload.url" class="button" :href="this.payload.url") {{ this.payload.urlLabel || 'Read more' }}
  //- h1(class="section-title") {{this.title}}
  //- vue-markdown.desc(:source='this.desc')
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'

import VueMarkdown from 'vue-markdown'
// import Textblock from '@/components/textblock'

import Question from '@/components/question'

// component instance
var Conversation = Vue.component('conversation', {
  name: 'Conversation',
  props: ['payload', 'id', 'showNavigation', 'clickableItem', 'showTitle'],
  components: { VueMarkdown, Question },
  data: function () {
    return {
      status: {
        error: {
          show: false,
          text: ''
        },
        saved: false
      },
      activeId: '',
      answers: [],
      showResult: false
    }
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'saveAnswer',
      'saveAnswers'
    ]),
    next (data) {
      console.log(data.index, 'next: ', data.index + 1)
      this.answers[data.index] = data

      const refs = this.payload.items

      if (this.activeId === refs[refs.length - 1].sys.id ||
        data.index > refs.length) {
        this.showResult = true
      } else {
        this.showResult = false
        this.setActiveItem({}, refs[data.index + 1].sys.id)
      }
    },
    saveResult () {
      this.saveAnswers({
        conversationId: {'en-US': this.id},
        id: {'en-US': Math.random().toString(36).substr(2, 36)},
        questions: {'en-US': this.payload.items},
        answers: {'en-US': this.answers}
      })
      this.status = {...this.status, saved: true}
    },
    kebabToCamel (s) {
      return s.replace(/(-\w)/g, m => m[1].toUpperCase())
    },
    setActiveItem (e, id) {
      // console.log(id, e);
      Vue.set(this, 'activeId', id)
    },
    splitRouteParams (url) {
      let base = url.split('?')[0]
      let paramStrings = url.split('?')[1]
      let params = []

      // console.log(base, paramStrings);

      if (Array.isArray(paramStrings)) {
        const s = paramStrings.split('&')
        s.forEach((n, i) => {
          const p = n.split('=')
          params[p[0]] = [p[1]]
        })
      } else {
        const p = paramStrings.split('=')
        params[p[0]] = [p[1]]
      }
      // trim prepended slash just in case
      base = base[0] === '/' ? base.substr(1) : base

      return { page: base, ...params }
    }
  },
  computed: {
    splitScores () {
      let results = {}

      this.answers.forEach((n, i) => {
        console.log(n)
        // COMBAK: only takes the first category for now since this is what we expect atm...
        if (n.categories[0]) {
          results[n.categories[0]]
            ? results[n.categories[0]] = {
              name: n.categories[0],
              rawValues: [n.value, ...results[n.categories[0]].rawValues],
              value: results[n.categories[0]].value + n.value
            }
            : results[n.categories[0]] = {
              name: n.categories[0],
              rawValues: [n.value],
              value: n.value
            }
        }
      })

      return results
    }
  },
  created () {
  },
  mounted () {
    this.$route.params.cid
      ? this.setActiveItem({}, this.$route.params.cid[0])
      : this.setActiveItem({}, this.payload.items[0].sys.id)
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default Conversation
</script>

<style lang="scss" scoped>
.conversation{
  margin-bottom: measure(sm);
}

.collection-inner{
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  align-items: center;
}

.two-up .item {
  padding: measure(xxs);
}
.three-up .item, .four-up .item {
  padding: measure(xxs);
}

.item{
  // padding: measure(xxs);
  // text-align: center;
  .desc {
    // line-height: 1.8 !important; // does not work on nested vue-markdown elements since scoped styles are applied inline at mount
    font-size: font-measure(xs);
  }
}

.title{}
.desc{}
.collection-title{
  text-align: center;
  color: get-color(primary);
  font-weight: 700;
}

// collection navigation
.collectionNav{
  display: flex;

  margin-bottom: measure(sm);

  .collectionNavItems{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: auto;

    border: 1px solid get-color(secondary);
    padding: .2rem;
    box-sizing: border-box;
  }

  .collectionNavItem{
    cursor: pointer;
    width: measure(m) + 1;
    height: measure(xs);
    text-align: center;
    margin: 0;

    line-height: 1.8;

    background: transparent;
    // border: 1px solid get-color(secondary);

    color: $black;

    transition: background .2s ease-out;

    &.active{
      background: get-color(secondary);
      color: $white;
    }
  }
}
.image{
  align-self: flex-start;
  // transform: scale(.5);
  transform-origin: top left;
  // margin-left: measure(sm);
  /* margin-top: -1rem; */
  @include breakpoint(small only) {
    flex: 0 0 100%;
    padding: measure(sm);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/conversation.vue